module.exports = __webpack_public_path__ + "static/media/Jellicent_gaussian2.5ae8d83f.png";